'use client';
import React, { useState } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/customercenter-ui/components/ui/accordion';
import AlsoBoughtContent from './alsoBoughtContent';

interface AlsoBoughtContentProps {
  data?: any;
  title?: any;
  siteId?: string;
  maxAlsoBoughtContentPerPage?: number;
  crossSell: boolean;
}

export const CrossSellItemsListCarousel: React.FC<AlsoBoughtContentProps> = ({
  data,
  title,
  siteId,
  maxAlsoBoughtContentPerPage,
  crossSell = true,
}) => {
  const [isLoading, setIsLoading] = useState(true); // State to track loading status
  const [productAvailable, setProductAvailability] = useState(false);

  const setProductsStatus = (productAvailability: boolean) => {
    setIsLoading(false);
    setProductAvailability(productAvailability);
  };

  return (
    <section
      className={`w-screen-9xl relative  ${!isLoading && productAvailable ? 'mx-auto px-4' : 'h-0 overflow-hidden'}`}
    >
      <section className="mx-auto max-w-[1390px]">
        <section className="relative w-[1016px]">
          <section className="mb-5 flex items-center justify-between">
            <Accordion type="single" collapsible className="w-full" defaultValue="item-1">
              <AccordionItem value="item-1" className="border-0">
                <AccordionTrigger className="border-b text-lg font-bold leading-6">
                  <strong className="text-2xl font-bold leading-8 text-black">{title}</strong>
                </AccordionTrigger>
                <AccordionContent className="pt-4">
                  <AlsoBoughtContent
                    siteId={siteId}
                    maxAlsoBoughtContentPerPage={maxAlsoBoughtContentPerPage}
                    data={data}
                    setProductsStatus={setProductsStatus}
                    crossSell={crossSell}
                  />
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </section>
        </section>
      </section>
    </section>
  );
};

export default CrossSellItemsListCarousel;
